(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-product-grid"] && !Shopify.designMode) return;
  try {
    
  /* Slider: gdy kart jest mniej niz kolumn, rozszerzamy karty na caly
     rzad (bez pustego slotu), a gdy nie ma czego przewijac, chowamy
     strzalki. Liczone po zaladowaniu i przy zmianie rozmiaru. */
  const racerGridFit = () => {
    document.querySelectorAll('.racer-grid-section--carousel').forEach((section) => {
      const track = section.querySelector('.racer-grid');
      if (!track) return;
      const cards = track.querySelectorAll('.racer-card').length;
      const cols = Number(getComputedStyle(section).getPropertyValue('--racer-cols')) || 4;
      const base = Number(section.dataset.racerCols || cols);
      section.dataset.racerCols = String(base);
      section.style.setProperty('--racer-cols', String(base));
      requestAnimationFrame(() => {
        section.classList.toggle('racer-grid-section--static', track.scrollWidth <= track.clientWidth + 2);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', racerGridFit);
  else racerGridFit();
  window.addEventListener('resize', racerGridFit);
  document.addEventListener('shopify:section:load', racerGridFit);

  /* Strzalki slidera „Zobacz tez”: przewijaja o szerokosc jednej karty. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-racer-grid-prev], [data-racer-grid-next]');
    if (!button) return;
    const section = button.closest('.racer-grid-section');
    const track = section && section.querySelector('.racer-grid');
    const card = track && track.querySelector('.racer-card');
    if (!card) return;
    const step = card.getBoundingClientRect().width + 10;
    const dir = button.hasAttribute('data-racer-grid-next') ? 1 : -1;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });

  // Karuzela w karcie — przewijanie o jeden slajd, delegacja zdarzeń,
  // więc działa też dla kart doładowanych przez infinite scroll.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-racer-prev], [data-racer-next]');
    if (!button) return;

    event.preventDefault();

    const gallery = button.closest('.racer-card__gallery');
    const track = gallery?.querySelector('[data-racer-track]');
    if (!track) return;

    const direction = button.hasAttribute('data-racer-next') ? 1 : -1;
    const step = track.clientWidth;
    let target = track.scrollLeft + direction * step;

    // Zawijanie na końcach, żeby karuzela była nieskończona jak u Racera.
    const max = track.scrollWidth - step;
    if (target > max + 1) target = 0;
    if (target < -1) target = max;

    track.scrollTo({ left: target, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-reels"] && !Shopify.designMode) return;
  try {
    
  class RacerReels extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-racer-reels-track]');
      this.prev = this.querySelector('[data-racer-reels-prev]');
      this.next = this.querySelector('[data-racer-reels-next]');

      if (this.track && this.prev && this.next) {
        this.addEventListener('click', this.handleClick);
        this.track.addEventListener('scroll', this.syncArrows, { passive: true });
        window.addEventListener('resize', this.syncArrows);
        this.syncArrows();
      }

      this.setupVideos();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.syncArrows);
      if (this.observer) this.observer.disconnect();
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-racer-reels-prev], [data-racer-reels-next]');
      if (!button) return;

      // Kafel jest linkiem, strzałka leży na nim. Zatrzymujemy zdarzenie,
      // żeby przesunięcie toru nie otwierało przy okazji Instagrama.
      event.preventDefault();
      event.stopPropagation();

      const tile = this.track.querySelector('.racer-reels__item');
      if (!tile) return;

      const step = tile.getBoundingClientRect().width + this.gap();
      const dir = button.hasAttribute('data-racer-reels-next') ? 1 : -1;
      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    gap() {
      const value = parseFloat(getComputedStyle(this.track).columnGap);
      return Number.isFinite(value) ? value : 0;
    }

    syncArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const scrollable = scrollWidth - clientWidth > 2;

      this.prev.classList.toggle('is-inert', !scrollable || scrollLeft <= 2);
      this.next.classList.toggle('is-inert', !scrollable || scrollLeft >= scrollWidth - clientWidth - 2);
    };

    setupVideos() {
      const videos = this.querySelectorAll('[data-racer-reel]');
      if (!videos.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        videos.forEach((video) => {
          video.removeAttribute('autoplay');
          video.pause();
        });
        return;
      }

      // Start bierze na siebie atrybut `autoplay` — to działa niezawodnie
      // dla wyciszonego wideo. Obserwator tylko wstrzymuje to, czego nie
      // widać, żeby kilka rolek naraz nie zjadało baterii.
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.play().catch(() => {});
            else entry.target.pause();
          });
        },
        { rootMargin: '200px', threshold: 0.1 }
      );

      videos.forEach((video) => this.observer.observe(video));
    }
  }

  if (!customElements.get('racer-reels')) {
    customElements.define('racer-reels', RacerReels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-stories"] && !Shopify.designMode) return;
  try {
    
  class RacerStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-racer-stories-track]');
      if (!this.track) return;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-racer-stories-prev], [data-racer-stories-next]');
        if (!button) return;

        event.preventDefault();
        const tile = this.track.querySelector('.racer-stories__tile');
        if (!tile) return;

        const step = tile.getBoundingClientRect().width + 10;
        const dir = button.hasAttribute('data-racer-stories-next') ? 1 : -1;
        this.track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      });

      this.setupAutoplay();

      // Filmy w torze grają tylko wtedy, gdy są widoczne.
      const videos = this.querySelectorAll('video');
      if (!videos.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) e.target.play().catch(() => {});
            else e.target.pause();
          });
        },
        { root: this.track, threshold: 0.5 }
      );
      videos.forEach((v) => io.observe(v));
    }
  }

  /* Powolne przewijanie w pętli (decyzja właściciela, 2026-09-06).
     Kafle są klonowane dwa razy (trzy kopie); pozycja trzymana jest
     w środkowej kopii, więc ruch i ręczne przewijanie w obie strony
     są ciągłe, bez skoku. Snap wyłączamy, bo walczyłby z rAF. Pauza na hover,
     dotyk, fokus i gdy sekcja nie jest widoczna; po puszczeniu palca
     rusza po 0,8 s, po strzałkach po 2 s. Szanuje prefers-reduced-motion. */
  RacerStories.prototype.setupAutoplay = function () {
    if (this.dataset.autoplay !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const track = this.track;
    const tiles = Array.from(track.children);
    if (tiles.length < 2) return;

    for (let copy = 0; copy < 2; copy += 1) {
      tiles.forEach((tile) => {
        const clone = tile.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-shopify-editor-block');
        track.appendChild(clone);
      });
    }

    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';

    const speed = Math.max(5, Number(this.dataset.speed) || 30); // px na sekundę
    let paused = false;
    let pauseUntil = 0;
    let visible = true;
    let last = null;
    let pos = track.scrollLeft;

    /* Okres pętli = odległość między pierwszym kaflem a jego klonem,
       liczona z układu, nie z połowy scrollWidth (padding i odstępy
       psułyby to o kilka px i pętla by „tykała"). */
    const period = () => track.children[tiles.length].offsetLeft - tiles[0].offsetLeft;

    /* Zawijanie działa też przy ręcznym przewijaniu: za końcem wraca
       na początek, przed początkiem skacze na drugą kopię — w obie
       strony bez końca. Start ustawiamy na drugą kopię, żeby od razu
       dało się przewijać w lewo. */
    let wrapped = false;
    const normalize = () => {
      const P = period();
      if (!P) return;
      if (!wrapped) { track.scrollLeft += P; wrapped = true; }
      const sl = track.scrollLeft;
      if (sl >= P * 2 - 1) { track.scrollLeft = sl - P; pos = track.scrollLeft; return; }
      if (sl < 1) { track.scrollLeft = sl + P; pos = track.scrollLeft; return; }
      /* Safari na iPhonie trzyma scrollLeft jako liczbe calkowita, a my
         dokladamy 0,25–0,5 px na klatke. Odczyt co klatke zaokraglal
         pozycje do poprzedniej wartosci i tasma stala w miejscu. Dlatego
         pozycje trzymamy w zmiennej i synchronizujemy ze scrollLeft
         tylko wtedy, gdy ktos naprawde przewinal (roznica > 1,5 px). */
      if (Math.abs(sl - pos) > 1.5) pos = sl;
    };

    const step = (now) => {
      if (last === null) last = now;
      const dt = Math.min(64, now - last);
      last = now;
      if (!paused && visible && now > pauseUntil) {
        pos += (speed * dt) / 1000;
        track.scrollLeft = pos;
      }
      normalize();
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);

    /* Pauza na hover tylko tam, gdzie hover naprawde istnieje. iOS wysyla
       mouseenter przy dotknieciu i nigdy mouseleave — taśma stawala na
       zawsze (zgloszenie wlasciciela: „nie przewija sie na telefonie"). */
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', () => { paused = true; });
      this.addEventListener('mouseleave', () => { paused = false; });
    }
    this.addEventListener('focusin', () => { paused = true; });
    this.addEventListener('focusout', () => { paused = false; });

    /* Dotyk: przesuniecie palcem konczy sie czesto touchcancel, nie
       touchend — bez tego pauza zostawala na stale. */
    const resume = () => { pauseUntil = performance.now() + 800; paused = false; };
    track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    track.addEventListener('touchend', resume, { passive: true });
    track.addEventListener('touchcancel', resume, { passive: true });
    track.addEventListener('pointercancel', resume);

    /* Bezpiecznik: gdyby pauza z jakiegos powodu zostala bez dotyku
       i bez fokusu, po 3 s ruszamy sami. */
    setInterval(() => {
      if (paused && !this.matches(':hover, :focus-within')) paused = false;
    }, 3000);
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-racer-stories-prev], [data-racer-stories-next]')) {
        pauseUntil = performance.now() + 2000;
      }
    });

    new IntersectionObserver((entries) => {
      visible = entries.some((e) => e.isIntersecting);
    }, { threshold: 0.1 }).observe(this);
  };

  if (!customElements.get('racer-stories')) {
    customElements.define('racer-stories', RacerStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["racer-tabs"] && !Shopify.designMode) return;
  try {
    
  class RacerTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length === 0) return;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      });

      this.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;

        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
        if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        if (next !== null) {
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');

        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      });
    }
  }

  if (!customElements.get('racer-tabs')) {
    customElements.define('racer-tabs', RacerTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
